 export const progskills = [
  {
    title: "C++",
    image: "/img/icons/c-.png",
  },
  {
    title: "C#",
    image: "/img/icons/c-sharp.png",
  },
  {
    title: "SQL",
    image: "/img/icons/sql-server.png",
  },
  {
    title: "JavaScript",
    image: "/img/icons/js.png",
  },
  {
    title: "HTML/CSS",
    image: "/img/icons/html_css.png",
  },
  {
    title: "React",
    image: "/img/icons/react.png",
  },
];

export const toolskills = [
  {
    title: "Visual Studio",
    image: "/img/icons/vs.svg",
  },
  {
    title: "Perforce Helix",
    image: "/img/icons/helix-core.png",
  },
  {
    title: "Ubisoft Anvil",
    image: "/img/icons/anvil.png",
  },
  {
    title: "Unreal Engine",
    image: "/img/icons/unreal.png",
  },
  {
    title: "Unity",
    image: "/img/icons/unity.png",
  },
  {
    title: "Git",
    image: "/img/icons/git.png",
  },
];